export const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_id",
] as const;

// inferred user ICP type from website passed as url param with first touch attribution
export const ICP_TYPE_PARAM = "lp_icp";
